import React from 'react'
import './Notification.css'

const Notification = ({ type, children, dismiss }) => (
  <div className={['notification', `notification-${type}`].join(' ')}>
    {children}
    <span className='material-icons' onClick={dismiss}>close</span>
  </div>
)

export default Notification



// WEBPACK FOOTER //
// ./src/components/Notification.js